var exports = {
  "k": "x31de4314--c5f2e8--container",
  "R": "x31de4314--c5f2e8--description-wrapper",
};

module.exports = exports;
